import { render, staticRenderFns } from "./SolicitacaoAbertura.vue?vue&type=template&id=326b33fe&"
import script from "./SolicitacaoAbertura.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAbertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SolicitacaoAbertura.vue"
export default component.exports